import { render, staticRenderFns } from "./ActiveQuoteCompareSettings.vue?vue&type=template&id=c8b32b92"
import script from "./ActiveQuoteCompareSettings.vue?vue&type=script&lang=js"
export * from "./ActiveQuoteCompareSettings.vue?vue&type=script&lang=js"
import style0 from "./ActiveQuoteCompareSettings.vue?vue&type=style&index=0&id=c8b32b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports